import ContactForm from '@/fragments/contact-form/ContactForm'
import Sections from '@/fragments/sections/Sections'

export default {
  components: {
    Sections,
    ContactForm
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
  }
}
